import { useMutation, useQueryClient } from '@tanstack/react-query';
import { IChatMessage } from 'src/@types/chat';
import { ChatRequests } from 'src/requests/chat';
import { useChatConversationContext } from 'src/sections/@dashboard/chat/ChatConversation/useChatConversationContext';

type Props = {
  channelId: string;
  id: string;
};

type ChatCache = {
  pages: Array<Array<IChatMessage | null>>;
};

export const useDeleteMessage = ({ channelId, id }: Props) => {
  const { goToMessage } = useChatConversationContext();
  const queryClient = useQueryClient();
  const messageId = id;

  const queryKey = ['channels', channelId, goToMessage];

  const { mutateAsync: deleteMessage, isLoading: isDeletingMessage } =
    useMutation({
      mutationFn: ChatRequests.deleteMessage,
      onSuccess: () => {
        queryClient.setQueryData<ChatCache>(
          queryKey,
          (cache) => {
            if (!cache) return cache;
            cache.pages = cache.pages.map((page) =>
              page.filter((message) => message?._id !== messageId),
            );
            return cache;
          },
          {
            updatedAt: Date.now(),
          },
        );
      },
    });

  return { deleteMessage, isDeletingMessage };
};
